import React from 'react';
import BoschIcon from './BoschIcon.js';

/**
 * Tile Component
 * @param boschIcon
 * @param title
 * @param text
 * @param link
 * @param color
 * @returns {JSX.Element}
 */
const Tile = ({
  boschIcon,
  title = null,
  text = null,
  color = null,
  link = null
}) => {
  const className = `ebds-tile ebds-tile--${color}`;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, link ? /*#__PURE__*/React.createElement("a", {
    href: link
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-tile__content"
  }, /*#__PURE__*/React.createElement(BoschIcon, {
    icon: boschIcon,
    srText: title
  }), title ? /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title) : null, text ? /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, text) : null)) : /*#__PURE__*/React.createElement("div", {
    className: "ebds-tile__content"
  }, /*#__PURE__*/React.createElement(BoschIcon, {
    icon: boschIcon,
    srText: title
  }), title ? /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title) : null, text ? /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, text) : null));
};
Tile.colors = ['fuchsia', 'violet', 'dark-blue', 'light-blue', 'turquoise', 'light-green', 'dark-green', 'gray'];
export default Tile;